import React from 'react';
import ChannelForm from '../ChannelForm';

import './channelCreate.css';

export function ChannelCreate() {
    return <ChannelForm isEdit={false} />;
}
